<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="6">
          <b-form-group label="Arrival" label-for="arrivalDate" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker :formats='dateformats' v-model="arrivalDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>

        </b-col>
        <b-col lg="6">
          <b-form-group label="Departure" label-for="departureDate" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker  :formats='dateformats'  v-model="departureDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-button variant="primary" class="pull-right" @click="search" :disabled="arrivalDate >= departureDate">
            Search
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

  <b-card no-body v-if="rooms.length > 0">
    <b-card-body>
      <strong>Selected rooms</strong>
      <b-row>
        <b-col lg="12">
          <v-client-table :data="rooms" :columns="roomColumns" :options="roomOptions" :theme="theme">
            <template slot="actions" slot-scope="data">
              <b-button class="mr-1" size="sm" variant="primary" @click="deleteRoom(data.row.id)">Delete</b-button>
            </template>
            <span slot="has_toilet" slot-scope="data">{{data.row.has_toilet ? data.row.toilet_type : 'No'}}</span>
            <span slot="has_ac" slot-scope="data">{{data.row.has_ac ? 'Yes' : 'No'}}</span>
          </v-client-table>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="12">
          <b-button variant="primary" class="pull-right" @click="createBooking">
            Book
          </b-button>
        </b-col>
      </b-row>

    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
      <strong>Available rooms</strong>
      <v-client-table :data="buildings" :columns="columns" :options="options" :theme="theme">
        <template slot="child_row" slot-scope="data">
          <floor-search :floors="data.row.floors" @selected="addRoom"></floor-search>
        </template>
      </v-client-table>
    </b-card-body>
  </b-card>

  <div>
    <b-modal ref="modalBookingForm" title="Booking Form" hide-footer size="lg">
      <booking-form v-if="rooms.length > 0" :arrival="arrivalDate" :departure="departureDate" :rooms="rooms" @success="successBookingForm" />
    </b-modal>

    <b-modal ref="modalSuccess" okOnly>
      <div class="d-block text-center">
        <h4>Form Has Been Submitted Succesfully.</h4>
      </div>
    </b-modal>
  </div>

</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
} from 'vuex'

import FloorSearch from './FloorSearch'
import BookingForm from './BookingForm'

export default {
  name: "AdminBooking",
  components: {
    FloorSearch,
    BookingForm
  },
  computed: mapState({
    buildings: state => state.reservations.availableBuildings,
    availRooms: state => state.reservations.availableRooms,
  }),
  watch: {
    arrivalDate() {
      this.rooms = []
    },
    departureDate() {
      this.rooms = []
    }
  },
  data() {
    return {
      arrivalDate: new Date(),
      departureDate: this.$moment().add(1, 'days').toDate(),
      rooms: [],
      columns: [
        'name',
        'avail_rooms',
      ],
      options: {
        headings: {
          name: 'Name',
          avail_rooms: 'Available Rooms',
        },
        filterable: [],
      },
      roomColumns: [
        'floor.building.name',
        'floor.floor_number',
        'room_number',
        'price',
        'number_of_beds',
        'max_occupiers',
        'has_toilet',
        'has_ac',
        'actions'
      ],
      roomOptions: {
        headings: {
          'floor.building.name': 'Building',
          'floor.floor_number': 'Floor',
          room_number: 'Room Number',
          price: 'Bhent',
          number_of_beds: "Beds",
          max_occupiers: "Max Occupiers",
          has_toilet: "Toilet",
          has_ac: "AC",
          actions: 'Actions'
        },
        filterable: [],
        perPage: 25,
      },
      theme: 'bootstrap4',
    }
  },
  methods: {
    search() {
      this.rooms = []
      this.$store.dispatch('reservations/searchAvailableRooms', {arrival: this.formatDate(this.arrivalDate), departure: this.formatDate(this.departureDate)})
    },
    createBooking() {
      this.$refs.modalBookingForm.show()
    },
    addRoom(room) {
      this.rooms.push(room)
      let availableRooms = _.filter(this.availRooms, item => item.id != room.id)
      this.$store.commit('reservations/setAvailableRooms', availableRooms)
    },
    deleteRoom(roomId) {
      this.rooms = _.filter(this.rooms, room => room.id != roomId)
    },
    successBookingForm() {
      this.$refs.modalBookingForm.hide()
      this.$refs.modalSuccess.show()
      this.rooms = []
    }
  },
  created() {
    this.$store.commit('reservations/clearAvailableRooms')
  }
}
</script>
